export default {
  TOGGLE_MODAL: "GIVING_FORM_LAUNCHER/TOGGLE_MODAL",
};
